export default __webpack_public_path__ + "static/media/to.7d1b5fa5.svg";